/* eslint-disable @next/next/no-img-element */
import { parseColor } from '@ark-ui/react'
import { LineChevronRightSmall } from '@qr-front/icons/line-chevron-right-small'
import { cn, isColorWhite } from '@qr-front/ui/utils'
import {
	socialLinkListAtom,
	TSocialLinkField,
} from 'features/generator/contentFormSections'
import {
	SOCIAL_PLATFORM_ICONS,
	SOCIAL_PLATFORM_LIST,
} from 'features/generator/utils/socialPlatformsConfig'
import { useAtomValue } from 'jotai'
import { addMissingUrlProtocol } from 'utils/urlUtils'

import { secondaryColorAtom } from '@/content-from-sections/client'

import { useColoredButton } from '../../../hooks/useColoredButton'

export const SocialLinkItem = ({
	item: { platformId, name, url, description },
	index,
	demoMode,
}: {
	item: TSocialLinkField
	index: number
	demoMode?: boolean
}) => {
	const secondaryColor = useAtomValue(secondaryColorAtom)
	const socialLinkList = useAtomValue(socialLinkListAtom)
	const { coloredButtonCls, coloredButtonStyle } =
		useColoredButton(secondaryColor)
	const isWhite = isColorWhite(parseColor)(secondaryColor)

	// Override background color for white secondary color
	const buttonStyle = isWhite
		? { ...coloredButtonStyle, backgroundColor: '#f5f6f7b3' }
		: coloredButtonStyle

	const Icon = SOCIAL_PLATFORM_LIST.find(({ id }) => id === platformId)?.[
		'Icon'
	]

	const customSocialImage = socialLinkList[index]?.logo

	return (
		<li>
			<a
				href={addMissingUrlProtocol(url || '')}
				target="_blank"
				rel="noreferrer"
				className={cn(
					coloredButtonCls,
					'flex items-center justify-between gap-2 rounded-6 p-2',
					isWhite && !demoMode && 'bg-transparent ring-1 ring-border-grey',
					demoMode && 'bg-light-grey-70',
				)}
				style={isWhite || demoMode ? undefined : buttonStyle}
			>
				<div className="type-body-caption flex items-center gap-2">
					{Icon ? <Icon className="shrink-0" /> : null}
					{customSocialImage?.publicId?.length ? (
						<div className="flex size-10 shrink-0 items-center justify-center">
							<img
								src={`${customSocialImage?.bucketRootUrl}/${socialLinkList[index]?.logo?.publicId}`}
								alt="Social image"
								width={33}
								height={33}
								className="rounded-full object-contain"
							/>
						</div>
					) : null}
					{customSocialImage?.src?.endsWith('custom-social.svg') ? (
						<SOCIAL_PLATFORM_ICONS.Web className="shrink-0" />
					) : null}
					<div className="flex flex-col">
						<p className="type-body-small font-semibold">{name}</p>
						<p className="type-body-caption font-normal opacity-75 word-break-fix">
							{description}
						</p>
					</div>
				</div>
				<LineChevronRightSmall className="size-4 shrink-0" />
			</a>
		</li>
	)
}
